import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {routeAnimation} from '../../../../route.animation';
import {FormBuilder, Validators} from '@angular/forms';
import {FormsService} from '../../../../_services/forms.service';
import {ActivatedRoute, Params} from '@angular/router';
import {ClientsService} from '../../../../_services/clients.service';
import {ClientsAttachments} from '../../../../_interfaces/clients/clients-attachment';
import {PreviousUrlService} from '../../../../_services/previous-url.service';
import {Subscription} from 'rxjs/Subscription';
import {ApiService} from '../../../../_interceptors/api.service';
import {PageTitleService} from '../../../../_services/page-title.service';
import {environment} from '../../../../../environments/environment';
import {Client} from '../../../../_interfaces/clients/clients';

@Component({
	selector: 'app-clients-attachments-edit',
	templateUrl: './clients-attachments-edit.component.html',
	styleUrls: ['./clients-attachments-edit.component.scss'],
	animations: [routeAnimation]
})

export class ClientsAttachmentsEditComponent implements OnInit, OnDestroy {

	@HostBinding('@routeAnimation') routerTransition = true;

	public client_id: number = null;
	public attachment_id: number = null;
	public dataLoaded: boolean = false;
	public missingData: Array<string> = [];

	public clientsAttachmentsEditForm = this.formBuilder.group({
		title: ['', [Validators.required, Validators.maxLength(100)]],
		description: [''],
		append_warehouse: [false],
		append_ladder: [false],
		append_tent: [false]
	});

	private _activatedRouteSubscription: Subscription = null;
	private _errorsSubscription: Subscription = null;

	constructor(public clientsService: ClientsService,
				public formsService: FormsService,
				private activatedRoute: ActivatedRoute,
				private formBuilder: FormBuilder,
				private apiService: ApiService,
				private previousUrlService: PreviousUrlService,
				private pageTitleService: PageTitleService) {
	}

	ngOnInit(): void {
		this.apiService.connectionChanged.subscribe(online => {
			if (online && this.missingData.length === 0) {
				this.loadData();
			}
		});

		this.formsService.form = this.clientsAttachmentsEditForm;

		this._errorsSubscription = this.clientsService.errors.subscribe(errors => {
			this.formsService.processErrors(errors);
		});

		this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params: Params) => {
			this.client_id = parseInt(params['client_id'], 10);
			this.attachment_id = parseInt(params['attachment_id'], 10);

			this.clientsService.getClient(this.client_id).then((client: Client) => {
				if (typeof client !== 'undefined') {
					this.pageTitleService.setTitle(client.company_name + ' | Bijlage aanpassen | ' + environment.webappName);
					this.pageTitleService.setPageTitle(client.company_name);
				}
			});

			this.loadData();

			this.previousUrlService.setPreviousUrlIfNull('clients/' + this.client_id + '/view');
		});
	}

	ngOnDestroy(): void {
		if (this._activatedRouteSubscription !== null) {
			this._activatedRouteSubscription.unsubscribe();
		}

		if (this._errorsSubscription !== null) {
			this._errorsSubscription.unsubscribe();
		}
	}

	loadData() {
		this.clientsService.getAttachment(this.client_id, this.attachment_id).then(attachment => {
			if (typeof attachment !== 'undefined') {
				this.formsService.populateForm(<ClientsAttachments>attachment);

				this.dataLoaded = true;
			} else {
				this.missingData.push('Bijlage');
			}
		});
	}
}
